<!-- Evaluation DIAGNOSES component -->
<template>
  <div>
    <md-card id="diagnoses" class="md-with-hover" @mouseover.native="mouseOver" @mouseleave.native="mouseLeave">
      <md-card-header class="md-card-header-icon md-card-header-warning">
        <div class="md-layout">
          <div class="card-icon" style="margin-left: 5px; margin-top: -7px; margin-right: 0px">
            <md-icon>graphic_eq</md-icon>
          </div>
          <div class="md-layout-item">
            <h4 class="title" style="font-weight: 400">DIAGNOSES &amp; RECOMMENDATIONS</h4>
          </div>
          <div class="md-layout-item md-alignment-center-right">
            <div style="display: flex; justify-content: flex-end">
              <!-- <md-button
                slot="title"
                class="md-button md-sm md-warning"
                style="margin: 15px 10px 0 0;"
                @click="mouseLeave"
                >Save Edits</md-button
              > -->
              <md-button
                slot="title"
                class="md-button md-sm md-success"
                style="margin: 15px 10px 0 0"
                @click="showDXOptions"
                >Dx Options</md-button
              >
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item">&nbsp;</div>
        </div>
        <hr />

        <div
          class="md-layout md-gutter md-alignment-space-around-center"
          style="text-align: center; margin-top: 15px; margin-bottom: 15px; display: block"
        >
          <md-field id="ddDiags" class="md-layout-item">
            <label style="margin-left: 24px; width: 100%; text-align: left; background-color: #fff"
              >Diagnoses (List each diagnosis on a new line, separated by commas)</label
            >
            <md-textarea id="diags" v-model="valuesDiagnoses" />
            <!-- v-model= dataDiagnoses" -->
          </md-field>
        </div>

        <!-- <hr /> -->

        <div class="md-layout md-gutter md-alignment-space-around-center" style="text-align: left; margin-top: 15px">
          <div v-if="mRecsHtml" id="ddRecsHtml" class="md-layout-item">
            <label
              style="
                margin-left: 5px;
                font-size: 11px;
                color: #aaaaaa;
                width: 100%;
                text-align: left;
                background-color: #fff;
              "
              >Recommendations</label
            >
            <html-textarea id="recs" v-model="valuesRecommendations" key:component-key-b />
          </div>

          <div v-else style="width: 100%">
            <md-field id="ddRecs" class="md-layout-item">
              <label style="margin-left: 25px; width: 100%; text-align: left; background-color: #fff"
                >Recommendations</label
              >
              <md-textarea id="recs" v-model="valuesRecommendations" />
            </md-field>
          </div>
        </div>

        <div
          align="left"
          class="md-layout md-gutter md-alignment-center-left"
          style="text-align: left; margin-top: 15px; margin-bottom: 15px"
        >
          <label style="margin-left: 25px; text-align: left" align="left">Disclaimer:</label>
          <p
            id="disclaimer"
            style="
              margin: 5px 40px;
              padding-right: 5px 40px;
              line-height: 0.97rem;
              font-size: 0.8rem;
              font-style: italic;
              color: #7e7e7e;
            "
          >
            {{ mDisclaimer }}
          </p>
        </div>

        <!---->
      </md-card-content>

      <hr />
    </md-card>

    <hr />

    <!-- MODAL DX & ICD10 -->
    <modal v-if="showDX" md-dynamic-height>
      <template slot="header">
        <div class="md-layout md-gutter md-alignment-center-space-between">
          <div class="md-layout-item">&nbsp;</div>
          <div class="md-layout-item" align="center">
            <span style="font-weight: 400; font-size: 1.5rem; color: black">D X &nbsp; &nbsp; O P T I O N S</span>
            <!-- <hr /> -->
          </div>
          <div class="md-layout-item" align="right">
            <md-icon class="exit-icon" style="color: red" @click.native="closeDxOptions">cancel</md-icon>
          </div>
        </div>
      </template>
      <template slot="body">
        <div class="md-layout md-gutter md-alignment-space-around-center">
          <div class="md-layout-item">
            <dx-options />
            <div style="margin-top: 1rem">
              <span style="font-weight: bold">Didn't find your Dx option?</span> Create a new one using
              <a href="#" style="text-decoration: underline; font-weight: bold" @click="openSearchDx">Dx Search</a>.
            </div>
            <!-- <md-button slot="title" class="md-button md-sm" style="margin: 15px 0 0 0;" @click="openSearchDx">
              Dx Search
            </md-button> -->
          </div>
        </div>
      </template>
    </modal>

    <!-- MODAL SEARCH DX -->
    <dx-search
      v-if="searchDxModal"
      :visible="searchDxModal"
      :selected-cards="selectedCards"
      :search-results="searchResults"
      :is-loading="isLoading"
      :is-create="isCreate"
      @update:selectedCards="selectedCards = $event"
      @update:searchResults="searchResults = $event"
      @closeModal="searchDxModal = false"
      @updateLoading="updateLoading"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import HtmlTextarea from "@/components/GlobeChek/html-textarea"
import { Modal } from "@/components"
import dxoptions from "@/components/GlobeChek/screening/findings/DxOptions"
import dxsearch from "@/components/GlobeChek/screening/findings/DxSearch"
import { bus } from "@/main"

export default {
  name: "EvalDiagnosis",
  components: {
    "html-textarea": HtmlTextarea,
    "dx-options": dxoptions,
    "dx-search": dxsearch,
    Modal
  },
  props: ["bus"],
  data() {
    return {
      mState: false,
      componentKeyA: 0,
      componentKeyB: 0,
      mRecsHtml: false,
      showDX: false,
      showDxBtn: false,
      dxRecommendations: [],

      mDisclaimer: `Your exam results were interpreted by a board-certified ophthalmologist or optometrist. GlobeChek® recommends regular eye exams as directed by the American Academy of Ophthalmology as well as the American Optometric Association. Do not disregard professional medical advice or delay in seeking it because of this exam. If you believe you may have a medical emergency, contact emergency care, visit an emergency room, or call 911 immediately.`,

      isLoading: false,
      searchDxModal: false,
      isCreate: false,
      searchResults: {},
      searchFormat: "",
      selectedCards: []
    }
  },
  watch: {
    ddFinalDiagnoses: {
      handler() {
        this.updateDiagnoses()
      },
      deep: true
    },
    ddFinalRecommendations: {
      handler() {
        this.updateRecommendations()
      },
      deep: true
    },
    "createFinding.isCreate": {
      handler(newVal, oldVal) {
        if (newVal && oldVal !== newVal) {
          this.handleCreateFinding()
        }
      }
    }
  },

  computed: {
    ...mapGetters([
      "omniPhoto",
      "omniSelected",
      "dxDiagnoses",
      "ddFinalDiagnoses",
      "ddFinalRecommendations",
      "evalResults",
      "dxOptionsList",
      "createFinding",
      "getSavedDiagnoses"
    ]),
    enableDxOptions() {
      return !this.showDxBtn
    },

    btnResetStyle() {
      return this.mState ? "md-primary" : ""
    },

    valuesDiagnoses: {
      get() {
        //console.log("count-Ds: ", this.ddFinalDiagnoses.length)
        // return this.ddFinalDiagnoses.length > 0 ? this.ddFinalDiagnoses.join("") : "Normal findings"
        let diagnoses = this.ddFinalDiagnoses
        if (diagnoses.length > 0) {
          diagnoses = diagnoses.map(
            (str) =>
              str
                .replace(/<br\s*\/?>/gi, "\n") // Replace <br />, <br>, <br    /> etc. with \n
                .replace(/[ \t]+/g, " ") // Normalize excessive spaces
                .replace(/\n\s+/g, "\n") // Remove indentation after line breaks
                .trim() // Remove leading/trailing whitespace
          )
        }
        return diagnoses.length > 0 ? diagnoses.join("\n") : ""
      },
      // eslint-disable-next-line no-unused-vars
      set(value) {
        const rawLines = value.split("\n")
        const cleaned = rawLines
          .map((line) => line.trim())
          .filter((line) => line.length > 0)
      
        this.$store.commit("UPDATE_FINAL_DIAGNOSES", cleaned)
      }
    },
    valuesRecommendations: {
      get() {
        //console.log("count-Rs: ", this.ddFinalRecommendations.length)
        let recommendations = this.ddFinalRecommendations
        if (recommendations.length > 0) {
          recommendations = recommendations.map(
            (str) =>
              str
                .replace(/<br\s*\/?>/gi, "\n") // Replace <br />, <br>, <br    /> etc. with \n
                .replace(/[ \t]+/g, " ") // Normalize excessive spaces
                .replace(/\n\s+/g, "\n") // Remove indentation after line breaks
                .trim() // Remove leading/trailing whitespace
          )
        }
        return recommendations.join("\n")
      },
      // eslint-disable-next-line no-unused-vars
      set(_value) {
        // Empty setter
      }
    },
    dataDiagnoses() {
      return this.dxDiagnoses.length > 0 ? this.getDxDiagnoses() : "dxDiagsLength=0"
    }
  },
  created() {
    this.resetState()
  },

  mounted: function () {
    this.updtMetrix()
    bus.$on("closeDxOptions", () => {
      this.showDX = false
    })
    bus.$on("dxSubmit", (data) => {
      this.updtDxOptions(data)
    })
  },

  methods: {
    getDxDiagnoses() {
      return Array.from(new Set(this.dxDiagnoses)).join(", ")
    },
    closeDxOptions() {
      this.showDX = false
    },
    updtMetrix() {
      this.$store.dispatch("updateFindingMetrics", null)
      if (this.ddFinalDiagnoses.length > 0) {
        this.dxDiagnoses.length = 0
      }
    },

    updtDxOptions(data) {
      const sections = ["External", "Cornea", "Pachymetry", "Opacity", "Fundus", "Macula", "Nerve"];
      sections.forEach(section => {
        if (this.omniPhoto(section)) {
          this.omniPhoto(section).diagnosesOD = [];
          this.omniPhoto(section).diagnosesOS = [];
          this.omniPhoto(section).diagnosesOU = [];
        }
      });
    
      if (!data || !Array.isArray(data.diagnoses)) {
        return;
      }

      if (data.unmarkedDiagnoses.length > 0) {
        // Get the diagnoses codes inside parentheses
        const diagnoses = data.unmarkedDiagnoses
          .map(x => x.match(/\((?=[^()]*\.[^()]*)[^()]+\)/g))
          .map(x => (x ? x[0] : null))
          .filter(x => x !== null)

        let remaining = this.valuesDiagnoses.split("\n")

        for (var unmarked of diagnoses) {
          remaining = remaining.filter(x => !x.includes(unmarked))
        }
        this.valuesDiagnoses = remaining.join("\n")
      }

      if (data.unmarkedRecommendations.length > 0) {
        const remaining = this.ddFinalRecommendations.filter(x => !data.unmarkedRecommendations.includes(x))
        this.valuesRecommendations = remaining.join(", <br />")
      }
    
      if (data.diagnoses.length === 0) return;
    
      const prefixMap = {
        ext: "External",
        cor: "Cornea",
        pac: "Pachymetry",
        opa: "Opacity",
        fun: "Fundus",
        mac: "Macula",
        nrv: "Nerve"
      };
    
      data.diagnoses.forEach(D => {
        if (!D || !D.optionID || !D.value) return;
      
        const prefix = D.optionID.split(".")[0];
        const section = prefixMap[prefix];

        if (!section || !this.omniPhoto(section)) {
          console.warn("Section not found for:", D.optionID);
          return;
        }
      
        const eyeSplit = D.value.split(".");
        if (eyeSplit.length < 2) return;
      
        const eye = eyeSplit[0];
        const diagnosis = D.value.substring(eye.length + 1);
        const eyeKey = `diagnoses${eye}`;
      
        if (Array.isArray(this.omniPhoto(section)[eyeKey])) {
          if (!this.omniPhoto(section)[eyeKey].includes(diagnosis)) {
            this.omniPhoto(section)[eyeKey].push(diagnosis);
          }
        }
      });

      //// RECOMMENDATIONS
      if (data.recommendations.length > 0) {
        let section = ""
        data.recommendations.forEach((R) => {
          switch (R.optionID.split(".")[0]) {
            case "ext":
              section = "External"
              break
            case "cor":
              section = "Cornea"
              break
            case "pac":
              section = "Pachymetry"
              break
            case "opa":
              section = "Opacity"
              break
            case "fun":
              section = "Fundus"
              break
            case "mac":
              section = "Macula"
              break
            case "nrv":
              section = "Nerve"
              break
          }
          if (R.value !== undefined) {
            this.omniPhoto(section).recommendOD.push(R.value)
          }

          // console.log("R-selected: " + section + " " + R.value)
          // console.log("DX-Rs: ", section, this.omniPhoto(section).recommendOD)
        })
      }

      this.$store.dispatch("loadSummary", null)
    },
    showDXOptions() {
      this.$store.dispatch("updateFindingMetrics", null)
      this.showDX = true
    },
    mouseOver: function () {
      this.updtResultsText()
      this.updtResutsHtml()
      this.componentKeyB += 1
      this.$forceUpdate()
    },
    mouseLeave: function () {
      this.updtResultsText()
      this.updtResutsHtml()
      this.$forceUpdate()
    },
    updateDiagnoses() {
      let dtxt = this.ddFinalDiagnoses.join("\n")
      let dhtm = this.ddFinalDiagnoses.join("<br>")
      this.evalResults.diagnoseTxt = dtxt
      this.evalResults.diagnoseHtml = dhtm
      // this.mDiagnoses = dtxt
    },
    updateRecommendations() {
      let rtxt = this.ddFinalRecommendations.join("\n")
      let rhtm = this.ddFinalRecommendations.join("<br>")
      this.evalResults.recommendText = rtxt
      this.evalResults.recommendHtml = rhtm

      // this.mRecommendations = rtxt

      this.mRecsHtml = rtxt.trim().substring(0, 4) === "<div"
      this.$forceUpdate()
    },
    updtResultsText() {
      //console.log("Updating text")
      let dtxt = document.querySelector("#diags").value //.value | .innerHTML
      let rtxt = document.querySelector("#recs").value //.value | .innerHTML
      this.evalResults.diagnoseTxt = dtxt
      this.evalResults.recommendText = rtxt
    },
    updtResutsHtml() {
      //console.log("Updating html")
      let dhtm = document.querySelector("#diags").value //.value | .innerHTML
      let rhtm = document.querySelector("#recs").value //.value | .innerHTML
      this.evalResults.diagnoseHtml = dhtm.replace(/\n/g, "<br />")
      this.evalResults.recommendHtml = rhtm.replace(/\n/g, "<br />")
    },
    openSearchDx() {
      this.isCreate = false
      this.searchDxModal = true
    },
    resetState() {
      this.$store.commit("RESET_EVAL_STATE")
    },
    updateLoading(value) {
      this.isLoading = value
    },
    handleCreateFinding() {
      this.isCreate = true
      this.searchDxModal = true
    }
  }
}
</script>

<style lang="scss" scoped>
#diagnoses {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}
.title1 {
  text-align: left;
  font-size: 0.96rem;
  color: black;
  font-weight: 400;
  margin-top: 16px;
  margin-bottom: 6px;
}

.exit-icon {
  cursor: pointer;
  margin: 0px;
  padding: 0px;
}
.search-results {
  margin-top: 20px;

  .results-container {
    height: 300px;
    width: 100%;
    overflow-y: auto;
    background-color: #f5f5f5;
    padding: 8px;
    margin-top: 0px;
    text-align: left;
    border: 1px solid #ddd;
    border-radius: 4px;

    // Add spacing for major sections
    > div {
      margin-bottom: 24px;
    }

    h3 {
      margin-top: 20px;
      margin-bottom: 12px;
    }

    ul {
      margin-top: 12px;
      margin-bottom: 16px;
    }

    li {
      margin-bottom: 6px;
    }

    p {
      margin-bottom: 15px;
      font-weight: 600;
      font-size: larger;
    }

    .no-bullets,
    .no-bullets li {
      list-style-type: none;
    }
  }
}

.md-field {
  margin-bottom: 16px;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 150px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 8px;
  width: 100%;
}
</style>
